import clsx from "clsx";
import type { ComponentProps } from "react";

import { PageHero } from "@widgets/page-hero";

import type { TitleWithIconType } from "@shared/content-types/types";

import s from "./Page.module.scss";

export type PageProps = ComponentProps<"div"> & {
  className?: string;
  children: React.ReactNode;
  title?: TitleWithIconType;
  description?: string;
};

export const Page = (props: PageProps) => {
  const { className, children, description, title } = props;

  return (
    <main className={clsx(s.root, className)}>
      {title && (
        <PageHero
          variant="primary"
          textColor="brown"
          title={title}
          description={description}
        />
      )}
      {children}
    </main>
  );
};

Page.displayName = "Page";
